import React, { useEffect, useCallback } from 'react';
import './SlidingPanel.css';

const SlidingPanel = ({
  isOpen,
  onClose,
  position = 'right',
  width = 400,
  children,
  title,
  showOverlay = true,
  closeOnEscape = true,
  closeOnOverlayClick = true,
}) => {
  // Handle escape key
  const handleEscape = useCallback((e) => {
    if (e.key === 'Escape' && isOpen && closeOnEscape) {
      onClose();
    }
  }, [isOpen, onClose, closeOnEscape]);

  useEffect(() => {
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [handleEscape]);

  // Prevent body scroll when panel is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const handleOverlayClick = () => {
    if (closeOnOverlayClick) {
      onClose();
    }
  };

  return (
    <>
      {/* Overlay */}
      {showOverlay && (
        <div
          className={`sliding-panel-overlay ${isOpen ? 'visible' : ''}`}
          onClick={handleOverlayClick}
          aria-hidden="true"
        />
      )}

      {/* Panel */}
      <div
        className={`sliding-panel sliding-panel--${position} ${isOpen ? 'open' : ''}`}
        style={{ '--panel-width': `${width}px` }}
        role="dialog"
        aria-modal="true"
        aria-label={title || 'Side panel'}
      >
        <div className="sliding-panel__header">
          {title && <h3 className="sliding-panel__title">{title}</h3>}
          <button
            className="sliding-panel__close"
            onClick={onClose}
            aria-label="Close panel"
            type="button"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15 5L5 15M5 5L15 15"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>
        <div className="sliding-panel__content">
          {children}
        </div>
      </div>
    </>
  );
};

export default SlidingPanel;
